import { render, staticRenderFns } from "./ad-product.vue?vue&type=template&id=5fc8e4ea&scoped=true&"
import script from "./ad-product.vue?vue&type=script&lang=js&"
export * from "./ad-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8e4ea",
  null
  
)

export default component.exports